import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import "./NewOrder.css";
import closeIcon from "../../assets/images/close.svg";
import { useAddNewOrderMutation } from "./orderSlice";
import { selectCurrentUser } from "./../auth/authSlice";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../components/common/LoadingSpinner/LoadingSpinner";
import { toast } from "react-hot-toast";
import { parse, format } from "date-fns";
import { useGetAllEmployeesQuery } from "../auth/employeeSlice";

const NewOrder = (props) => {
  const user = useSelector(selectCurrentUser);
  const [addNewOrder, { isLoading }] = useAddNewOrderMutation();

  const [orderId, setOrderId] = useState(0);
  const [tag, setTag] = useState(user.tag);
  const [enquiry, setEnquiry] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerStatus, setCustomerStatus] = useState("");
  const [amount, setAmount] = useState("");
  const [orderDate, setOrderDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [employeeData, setEmployeedata] = useState([]);

  const {
    data: employees,
    isFetching,
    isError,
    error,
  } = useGetAllEmployeesQuery();

  useEffect(() => {
    if (employees) {
      const data = employees.ids.map((id) => {
        return employees.entities[id];
      });
      setEmployeedata(data);
    }
  }, [employees]);

  const onTagChanged = (e) => setTag(e.target.value);
  const onEnquiryChanged = (e) => setEnquiry(e.target.value);
  const onCustomerNameChanged = (e) => setCustomerName(e.target.value);
  const onCustomerStatusChanged = (e) => setCustomerStatus(e.target.value);
  const onAmountChanged = (e) => setAmount(e.target.value);
  const onOrderDateChanged = (e) => setOrderDate(e.target.value);

  const canSave =
    [tag, enquiry, customerName, customerStatus, amount, user, orderDate].every(
      Boolean
    ) && !isLoading;

  const onSaveOrderClicked = async () => {
    if (canSave) {
      if (amount <= 0) {
        toast.error("Amount should be greater than £0");
        return;
      }
      try {
        await addNewOrder({
          orderId: orderId,
          orderTag: tag,
          enquiry,
          customerName,
          customerStatus: customerStatus === "YES" ? true : false,
          orderAmount: amount,
          createById: user.userID,
          orderDate: orderDate,
        }).unwrap();

        setTag("");
        setEnquiry("");
        setCustomerName("");
        setCustomerStatus("");
        setAmount(0);
        setOrderDate("");
        props.onClose();
        if (props.isUpdate) {
          toast.success("Order updated!");
        }
      } catch (err) {
        toast.error("Failed to save the Order");
      }
    }
  };

  useEffect(() => {
    if (props.isUpdate) {
      setTag(props.updateRow.orderTag);
      setEnquiry(props.updateRow.enquiry);
      setCustomerName(props.updateRow.customerName);
      setCustomerStatus(props.updateRow.customerStatus ? "YES" : "NO");
      setAmount(props.updateRow.orderAmount);
      setOrderId(props.updateRow.orderId);
      const parsedDate = parse(
        props.updateRow.orderDate,
        "dd MMMM yyyy",
        new Date()
      );
      const formattedDate = format(parsedDate, "yyyy-MM-dd");
      setOrderDate(formattedDate);
    }
  }, [props.isUpdate]);

  return (
    <>
      <Modal
        isOpen={props.show}
        toggle={props.onClose}
        className="modal-dialog-centered rounded"
      >
        <div className="bg-nav p-2 rounded">
          {isLoading && <LoadingSpinner />}
          <div className="header-gradient p-2 child rounded d-flex justify-content-between mb-2">
            <h6 className="modal-title" id="title">
              {props.isUpdate ? "Update Order" : "Add New Order"}
            </h6>
            <button
              type="button"
              className="closeBtn"
              aria-label="Close"
              onClick={props.onClose}
            >
              <img src={closeIcon} style={{ width: "70px" }} alt="" />
            </button>
          </div>
          <div className="bg-white p-2">
            <form className="p-2">
              <div className="row">
                <div className="form-group col-sm-12 col-md-12">
                  <label htmlFor="date" className="text-muted">
                    Date
                  </label>
                  <input
                    type="date"
                    className="form-control custom-input"
                    id="date"
                    value={orderDate}
                    onChange={onOrderDateChanged}
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-md-6">
                  <label htmlFor="tag" className="text-muted">
                    Tag
                  </label>
                  <select
                    className="form-control custom-input"
                    id="tag"
                    value={tag}
                    onChange={onTagChanged}
                  >
                    {employeeData.map((employee, index) => (
                      <option key={index} value={employee.tag}>
                        {employee.tag}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-sm-12 col-md-6">
                  <label htmlFor="enquiryReferenceNo" className="text-muted">
                    Enquiry Reference No.
                  </label>
                  <input
                    type="text"
                    className="form-control custom-input"
                    id="enquiry"
                    value={enquiry}
                    onChange={onEnquiryChanged}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="clientName" className="text-muted">
                  Client Name
                </label>
                <input
                  type="text"
                  className="form-control custom-input"
                  id="clientName"
                  value={customerName}
                  onChange={onCustomerNameChanged}
                />
              </div>
              <div className="mb-3">
                <span className="text-muted me-3"> New Client? </span>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="newClient"
                    id="yesRadio"
                    value="YES"
                    checked={customerStatus === "YES"}
                    onChange={onCustomerStatusChanged}
                  />
                  <label
                    className="form-check-label checkbox-label"
                    htmlFor="yesRadio"
                  >
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="newClient"
                    id="noRadio"
                    value="NO"
                    checked={customerStatus === "NO"}
                    onChange={onCustomerStatusChanged}
                  />
                  <label
                    className="form-check-label checkbox-label"
                    htmlFor="noRadio"
                  >
                    No
                  </label>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label htmlFor="inputCity" className="text-muted">
                    Amount(£)
                  </label>
                  <input
                    type="number"
                    className="form-control custom-input"
                    id="amount"
                    min={0}
                    value={amount}
                    onChange={onAmountChanged}
                  />
                </div>
              </div>

              <button
                type="button"
                className="btn btn-gradient w-100"
                onClick={onSaveOrderClicked}
                disabled={!canSave}
              >
                {props.isUpdate ? "Update Order" : " Add Order"}
              </button>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NewOrder;
